export function fmtEuro(value) {
  return Number(value || 0).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function stockStatusBadge(quantite, seuil = 3, quantiteDepot = 0) {
  const total = (quantite || 0) + (quantiteDepot || 0);
  if (total === 0) {
    return { label: 'Rupture', className: 'bg-red-950/40 text-red-300 border-red-500/30' };
  }
  if (quantite === 0 && quantiteDepot > 0) {
    return { label: 'En dépôt', className: 'bg-white/10 text-gray-300 border-white/15' };
  }
  if (quantite <= seuil) {
    return { label: 'Faible', className: 'bg-amber-950/40 text-amber-200 border-amber-500/30' };
  }
  return { label: 'OK', className: 'bg-emerald-950/40 text-emerald-300 border-emerald-500/30' };
}

export function stockPhotoUrl(path) {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${process.env.REACT_APP_BACKEND_URL || ''}${path}`;
}
